import React, { useState, useEffect } from "react";
import Lottie from "react-lottie";
import animationData from "../../assets/wheat.json";
import { usePredictedYield } from "../../contexts/usePredictedYield";

const YieldReportModal = () => {
  const { data, loading } = usePredictedYield();
  const [area, setArea] = useState(null);
  const [predictedValue, setPredictedYield] = useState(null);

  const reportAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  
  useEffect(() => {
    if (data) {
      const { area_in_sq_m, predicted_yield } = data;
      setPredictedYield(predicted_yield);
      setArea(area_in_sq_m);
    }
  }, [data]);

  return (
    <div
      className={`md:mt-2 bg-base-100 h-[45vh] w-full p-4 rounded-md border overflow-x-hidden  lg:overflow-hidden`}
    >
      <h1 className="font-bold bg-[#dbeafe] h-10 pt-1 text-center rounded-sm text-2xl">Yield Predicted Report</h1>
      <div >
        {loading ? (
          <div className="flex justify-center items-center animate-pulse h-[30vh]">
           
            <p className="text-gray-500 text-center mt-2">The report will be ready soon...</p>
          </div>
        ) : data ? (
          // Predicted yield report after loading is complete
          <div className="flex flex-col bg-white mt-2 p-6 rounded-xl shadow-lg w-full max-w-3xl mx-auto items-center justify-center">
            <p className="text-2xl">
              Predicted yield:{" "}
              <span className="font-bold text-green-600 ">
                {predictedValue ? predictedValue.toFixed(2) : ""}
              </span>{" "}
              tons per hectare.
            </p>
            <p className="text-2xl">
            The Area:{" "}
              <span className="font-bold text-green-600">
                {area ? (area / 10000).toFixed(2) : ""}
              </span>{" "}
              hectares.
            </p>
            <div className="mt-4 h-28 w-28" >
        <Lottie
          options={reportAnimationOptions}
          className="rounded-lg shadow-lg"
        />
      </div>
          </div>
        ) : (
          // Message when no data is available
          <p className="text-gray-400 mt-5 lg:mt-20">
            To see the predicted yield report, first fill the yield monitoring
            fields, press the "Predict Yield" button, and wait for processing.
          </p>
        )}
        
      </div>
      
    </div>
  );
};

export default YieldReportModal;